import { useState, useRef, type FC } from "react";
import SideNav from "../nav/SideNav";
import {
  ComponentBaseContainer,
  ComponentContainer,
  JsonContainer,
  JsonHelperContainer,
  JsonTextContainer,
  StyledClearIcon,
  StyledCopyIcon,
} from "../jsonformatter/JsonFormatter.style"; // Reusing styles
import "ace-builds/src-noconflict/mode-text";
import Divider from "@mui/material/Divider";
import AdsComponent from "../AdsComponent";

const RegexTester: FC = () => {
  const [pattern, setPattern] = useState<string>("");
  const [replacement, setReplacement] = useState<string>("");
  const [text, setText] = useState<string>("");
  const [matchCount, setMatchCount] = useState<number>(0);
  const [replacedText, setReplacedText] = useState<string>("");
  const [showToast, setShowToast] = useState(false);

  const inputRef = useRef<any>(null);
  const patternRef = useRef<any>(null);
  const outputRef = useRef<any>(null);

  const handleChange = (newText: string) => {
    setText(newText);
    try {
      const regex = new RegExp(pattern, "g");
      const matches = newText.match(regex);
      setMatchCount(matches?.length || 0);

      if (replacement !== "") {
        const replaced = newText.replace(regex, replacement);
        setReplacedText(replaced);
      } else {
        setReplacedText("");
      }
    } catch {
      setMatchCount(0);
      setReplacedText("Invalid regex");
    }
  };

  const handlePatternChange = (newPattern: string) => {
    setPattern(newPattern);
    handleChange(text);
  };

  const handleReplacementChange = (newReplace: string) => {
    setReplacement(newReplace);
    handleChange(text);
  };

  const handleClear = () => {
    inputRef.current?.editor?.setValue("", -1);
  };

  const handleCopy = () => {
    const content = outputRef.current?.editor?.getValue();
    content &&
      navigator.clipboard.writeText(content).then(() => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1000);
      });
  };

  return (
    <ComponentBaseContainer>
      <SideNav />
      <ComponentContainer>
        <JsonContainer>
          <JsonHelperContainer onClick={handleClear}>
            <StyledClearIcon />
          </JsonHelperContainer>
          <Divider />
          <JsonTextContainer
            placeholder="Enter text to test your regex..."
            ref={inputRef}
            mode="text"
            name="regex-input"
            value={text}
            onChange={handleChange}
            wrapEnabled
            setOptions={{
              useWorker: false,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
        </JsonContainer>

        <Divider orientation="vertical" />

        <JsonContainer>
          <JsonHelperContainer onClick={handleCopy}>
            <StyledCopyIcon />
          </JsonHelperContainer>
          <Divider />
          <JsonTextContainer
            placeholder="Matched output or replaced text will show here..."
            ref={outputRef}
            mode="text"
            name="regex-output"
            value={replacedText || text}
            wrapEnabled
            readOnly
            setOptions={{
              useWorker: false,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
        </JsonContainer>
      </ComponentContainer>

      {/* Regex pattern + replace UI */}
      <div style={{ padding: "10px 20px", color: "white" }}>
        <div>
          <label>Regex Pattern: </label>
          <input
            ref={patternRef}
            value={pattern}
            onChange={(e) => handlePatternChange(e.target.value)}
            placeholder="e.g. \\d+"
            style={{
              padding: "4px 8px",
              margin: "5px 10px 10px 0",
              borderRadius: "4px",
              fontSize: "14px",
            }}
          />
          <label>Replace With: </label>
          <input
            value={replacement}
            onChange={(e) => handleReplacementChange(e.target.value)}
            placeholder="optional"
            style={{
              padding: "4px 8px",
              margin: "5px 10px",
              borderRadius: "4px",
              fontSize: "14px",
            }}
          />
          <span style={{ fontStyle: "italic", fontSize: "13px" }}>
            Matches: {matchCount}
          </span>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#323232",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            opacity: 0.9,
            fontSize: "14px",
          }}
        >
          Copied to clipboard!
        </div>
      )}
      <AdsComponent />
    </ComponentBaseContainer>
  );
};

export default RegexTester;
